<template>
  <v-app>
    <confirmDlg ref="confirm"></confirmDlg>
    <messageDlg ref="message"></messageDlg>
    <loaderDlg ref="loader"></loaderDlg>
    <RwNavigationDrawer v-if="signedIn" v-model="drawerMenu">
      <template v-slot:menu-content>
        <Menu />
      </template>
    </RwNavigationDrawer>
    <RwHeader v-if="signedIn">
      <template v-slot:bar-nav-icon>
        <v-app-bar-nav-icon
          @click.stop="drawerMenu = !drawerMenu"
        ></v-app-bar-nav-icon>
        <img :src="logoFilename" />
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="signout()">
              <v-icon>mdi-export</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("global.disconnect") }}</span>
        </v-tooltip>
      </template>
    </RwHeader>
    <v-main>
      <router-view />
    </v-main>
    <RwFooter />
  </v-app>
</template>

<script>
import RwNavigationDrawer from "@/components/NavigationDrawer.vue";
import RwHeader from "@/components/Header.vue";
import RwFooter from "@/components/Footer.vue";
import confirmDlg from "@/components/ConfirmDlg.vue";
import messageDlg from "@/components/MessageDlg.vue";
import loaderDlg from "@/components/Loader.vue";
import Menu from "./views/Menu.vue";
import Vue from "vue";
import * as themesVuetify from "./plugins/themes.js";

require("@/css/application.css");

export default {
  name: "App",

  components: {
    RwNavigationDrawer,
    RwHeader,
    RwFooter,
    confirmDlg,
    messageDlg,
    loaderDlg,
    Menu
  },

  data: () => ({
    drawerMenu: false,
    signedIn: false,
    organization: "alerce"
  }),
  methods: {
    signout() {
      Vue.$keycloak.logout();
    },
    async refreshActiveUser() {
      try {
        this.organization = Vue.$keycloak.tokenParsed.tenant;
        this.organizationStyles(this.organization);
        this.signedIn = true;
      } catch (err) {
        this.signedIn = false;
      }
    },
    organizationStyles(value) {
      if (value === "XPO") {
        this.$vuetify.theme.themes.light = themesVuetify.xpo;
      } else {
        this.$vuetify.theme.themes.light = themesVuetify.alerce;
      }
    }
  },
  watch: {
    // everytime a route is changed refresh the activeUser
    $route: "refreshActiveUser"
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$message = this.$refs.message.open;
    this.$root.$loading = this.$refs.loader.show;
    this.$root.$loaded = this.$refs.loader.hide;
  },
  computed: {
    logoFilename() {
      try {
        return require("@/assets/logo-" + this.organization + ".svg");
      } catch (error) {
        return "";
      }
    }
  }
};
</script>
